import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  /** Doi gia tri nay (vd duong dan) thi xoa loi va thu ve lai — chuyen trang khong bi ket man hinh loi. */
  resetKey?: unknown;
  fallback: (error: Error, reset: () => void) => ReactNode;
  children: ReactNode;
}

interface State {
  error: Error | null;
  key: unknown;
}

/**
 * Chan loi khi ve giao dien: mot trang hong khong lam trang ca ung dung (React go ca cay khi
 * loi render khong duoc bat).
 */
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null, key: this.props.resetKey };

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { error };
  }

  static getDerivedStateFromProps(props: Props, state: State): Partial<State> | null {
    if (props.resetKey !== state.key) return { error: null, key: props.resetKey };
    return null;
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  private reset = () => this.setState({ error: null });

  override render(): ReactNode {
    return this.state.error ? this.props.fallback(this.state.error, this.reset) : this.props.children;
  }
}
